/**
 * FCM Integration Component
 * 
 * Renders FCM-related UI components (toast, navigation handler).
 * Note: FCMNotificationProvider is now at App.js level for global access.
 */

import React from 'react';
import NotificationToast from '../NotificationToast';
import FCMNavigationHandler from '../FCMNavigationHandler';

const FCMIntegration = ({ children }) => {
  return (
    <>
      {/* Main app content */}
      {children}
      
      {/* Navigation handler - handles click actions */}
      <FCMNavigationHandler />
      
      {/* In-app toast notifications - top right corner */}
      <NotificationToast />
    </>
  );
};

export default FCMIntegration;
